import modalMixin from '../../../mixins/_modal';
import commonMixin from '../../../mixins/_common';
import flashMessageMixin from '../../../mixins/_flash_messages';

/**
 * 配送方法削除コンポーネント
 */
export default {
    name: 'ShippingDataDelete',
    template: '#delivery_shipping_data_delete_template',
    data() {
        return {
            // 削除対象配送方法インデックス
            index: null,
            // 削除対象配送方法
            shipping: {},
            // 初期削除対象配送方法
            default_shippings: {},
        };
    },
    props: {
        // 配送方法リスト
        prop_shippings: {
            type: Array,
            required: true
        },
        // 配送グループリスト
        prop_delivery_groups: {
            type: Array,
            required: true
        }
    },
    mixins: [
        modalMixin,
        commonMixin,
        flashMessageMixin,
    ],
    computed: {
        shippings: {
            get() {
                return this.prop_shippings;
            },
            set(val) {
                this.$emit('update:prop_shippings', val);
            }
        },
        delivery_groups: {
            get() {
                return this.prop_delivery_groups;
            },
            set(val) {
                this.$emit('update:prop_delivery_groups', val);
            }
        },
    },
    emits: [
        'update:prop_shippings',
        'update:prop_delivery_groups',
    ],
    mounted : function(){
        // 初期表示時の配送方法リストを保持
        this.default_shippings = _.cloneDeep(this.shippings);
    },
    methods: {
        // コンポーネントを開く
        show: function (index) {
            this.index = index;
            this.shipping = _.cloneDeep(this.shippings[this.index]);

            // 対象配送方法が配送グループで個別指定されている場合は削除不可
            // 例外：削除対象の配送方法が最後の一つである場合はスキップ
            if (!this.canDeleteShipping(this.shipping.no) && this.shippings.length !== 1 ) {
                this.appendFlashMessage({
                    level: 'alert-danger',
                    message: 'この配送方法は「配送グループ」で指定されているため削除できません。配送グループから外すか、配送グループの設定を「自動で追加する」に変更してください。',
                }, this.$parent);
                return;
            }

            // 新規作成された配送方法の場合は、モーダルを開かず削除する
            if (!this.default_shippings.length || this.shipping.no > this.default_shippings[this.default_shippings.length - 1].no) {
                this.updateDeliveryData(this.shipping.no);
                return;
            }

            // モーダルを開く
            this.open();
        },
        // 対象の配送方法は削除可能か
        // 配送グループで該当の配送方法が個別指定されていると、
        // 配送方法削除後に配送グループに登録されている配送方法がなくなりエラーとなるため。
        canDeleteShipping: function (no) {
            const deliveryGroupsHaveDeleteNo = this.delivery_groups.filter(function(deliveryGroup){
                // 「自動で追加する」がONの場合は、配送方法を削除しても自動採番されるためチェックしない
                if (!deliveryGroup.delivery_methods_auto_sync == 1) {
                    return deliveryGroup.delivery_methods.indexOf(no) !== -1;
                }
            }, no);
            // 全ての配送グループで未使用であれば削除可能
            return (!deliveryGroupsHaveDeleteNo.length);
        },
        // 配送方法、配送グループを削除および更新する
        deleteSavedDeliveryData: async function () {
            let message = this.exception_error_message;
            try {
                this.$_loading();
                const response = await axios.delete('/setup/delivery/delete',
                    {
                        data: {
                            _method: 'DELETE',
                            no: this.shipping.no,
                        },
                    });

                if (response.data.status === 'OK') {
                    // 初期配送方法リスト更新
                    this.default_shippings = response.data.shop_shippings;
                    // 配送リスト、配送グループリストを更新
                    this.updateDeliveryData(this.shipping.no);
                    // エラーメッセージを空にする
                    message = '';
                }
            } catch (e) {
                message = this.getCatchMessage(e);
            }
            this.$_unloading();
            if (message) {
                this.appendFlashMessage({
                    level: 'alert-danger',
                    message: message,
                }, this.$parent);
            }
            // モーダルを閉じる
            this.close();
        },
        // 配送方法、配送グループを更新する
        updateDeliveryData: function (no) {
            this.updateDeliverygroups(no);
            this.updateShippings(no);
        },
        // 配送方法リストを更新する
        updateShippings: function (no) {
            let shippings = _.cloneDeep(this.shippings);
            const deleteShippingIndex = shippings.findIndex(function(shipping) {
                return shipping.no === no;
            });
            // 該当配送方法を削除
            shippings.splice(deleteShippingIndex, 1);
            // 再採番
            this.shippings = shippings.map((shipping) => {
                if (shipping.no > no) {
                    shipping.no = shipping.no - 1;
                }
                return shipping;
            }, no);
        },
        // 配送グループリストを更新する
        updateDeliverygroups: function (no) {
            let deliveryGroups = _.cloneDeep(this.delivery_groups);
            this.delivery_groups = deliveryGroups.map(function(deliveryGroup){
                let deliveryMethods = _.cloneDeep(deliveryGroup.delivery_methods);
                const deleteShippingIndex = deliveryMethods.indexOf(no);

                // 該当noを削除
                if (deleteShippingIndex !== -1) {
                    deliveryMethods.splice(deleteShippingIndex, 1);
                }

                // 再採番
                for (let i = 0; i < deliveryMethods.length; i++) {
                    if (deliveryMethods[i] > no) {
                        deliveryMethods[i] = deliveryMethods[i] - 1;
                    }
                }

                // 選択中配送方法が一つもなくなったら「自動で追加する」をONにしておく
                if (!deliveryMethods.length) {
                    deliveryGroup.delivery_methods_auto_sync = 1;
                }

                deliveryGroup.delivery_methods = deliveryMethods;
                return deliveryGroup;
            }, no);
        },
    }
};
